"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCardManager = void 0;
const dom_1 = require("./utils/dom");
const event_bus_1 = require("./utils/event-bus");
const spreedly_config_1 = require("./config/spreedly.config");
const field_null_exeption_1 = require("./exceptions/field-null.exeption");
const error_types_contants_1 = require("./constants/error-types.contants");
const event_types_constants_1 = require("./constants/event-types.constants");
const credit_card_validation_1 = require("./utils/credit-card-validation");
const credit_card_constants_1 = require("./constants/credit-card.constants");
const mappers_1 = require("./utils/mappers");
const is_spreedly_1 = require("./utils/is-spreedly");
class ReplaceCardManager {
    constructor(token, isProduction) {
        this.token = token;
        this.isProduction = isProduction;
        this.dom = new dom_1.Dom();
        this.eventBus = event_bus_1.EventBus.getInstance();
    }
    withCardNumber(options) {
        this.cardNumber = {
            elementId: options.elementId,
            name: 'card_number',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withCVV(options) {
        this.cvv = {
            elementId: options.elementId,
            name: 'card_cvv',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withExpirationDate(options) {
        this.expirationDate = {
            elementId: options.elementId,
            name: 'expiration_date',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    build() {
        if (!this.cvv) {
            throw new field_null_exeption_1.FieldNullException('CVV');
        }
        if (!this.cardNumber) {
            throw new field_null_exeption_1.FieldNullException('card number');
        }
        if (!this.expirationDate) {
            throw new field_null_exeption_1.FieldNullException('expiration date');
        }
        this.dom
            .loadSpreedlyScript()
            .then(() => {
            this.initSpreedly();
            this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.REPLACE_CARD_READY);
        })
            .catch(error => this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.REPLACE_CARD_ERROR, error));
    }
    initSpreedly() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.init(this.isProduction ? spreedly_config_1.SpreedlyConfig.PROD : spreedly_config_1.SpreedlyConfig.DEV, {
                numberEl: this.cardNumber.elementId,
                cvvEl: this.cvv.elementId
            });
        }
        this.startSpreedlyEvents();
    }
    startSpreedlyEvents() {
        Spreedly.on('ready', () => {
            Spreedly.setRecache(this.token);
            Spreedly.setFieldType('number', 'text');
            Spreedly.setStyle('number', 'display: none');
            Spreedly.setPlaceholder('cvv', this.cvv.placeholder);
            Spreedly.setStyle('cvv', 'width: 100%; height: 100%; padding: 0px;');
        });
        this.initState();
        this.notifyChangeState();
        this.expirationDateInput = this.dom.createHTMLInputText({
            parentId: this.expirationDate.elementId,
            name: this.expirationDate.name,
            placeholder: this.expirationDate.placeholder
        });
        // events for input expiration date
        this.expirationDateInput.addEventListener('keypress', (event) => this.onKeypressExpirationDate(event));
        this.expirationDateInput.addEventListener('keydown', (event) => this.onkeydownExpirationDate(event));
        this.expirationDateInput.addEventListener('paste', (event) => event.preventDefault());
        this.expirationDateInput.addEventListener('input', () => this.onInputExipirationDate());
        this.expirationDateInput.addEventListener('focusin', () => this.notifyFocusInElement(this.expirationDateInput.name));
        this.expirationDateInput.addEventListener('focusout', () => this.notifyFocusOut());
        Spreedly.on('fieldEvent', (name, type, activeEl, inputProperties) => {
            switch (name) {
                case 'cvv':
                    if (type === 'input') {
                        this.state[this.cvv.name].isValid = inputProperties.validCvv;
                        this.state[this.cvv.name].error = inputProperties.validCvv ? error_types_contants_1.ErrorTypes.EMPTY : error_types_contants_1.ErrorTypes.INVALID_CVV;
                        this.notifyChangeState();
                    }
                    else if (type === 'focus') {
                        this.notifyFocusInElement(this.cvv.name);
                    }
                    else if (type === 'blur') {
                        this.notifyFocusOut();
                    }
                    break;
            }
        });
    }
    addEventListener(eventName, cb) {
        this.eventBus.addEventListener(eventName, cb);
    }
    notifyFocusInElement(element) {
        this.state[element].isFocused = true;
        this.notifyChangeState();
    }
    notifyChangeState() {
        this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.INPUT_CHANGE, this.state);
    }
    notifyFocusOut() {
        Object.keys(this.state).forEach((key) => this.state[key].isFocused = false);
        this.notifyChangeState();
    }
    onKeypressExpirationDate(event) {
        if (!credit_card_validation_1.CreditCardValidation.restrictNumeric(event.key) || credit_card_validation_1.CreditCardValidation.restrictExpiry(event.key, this.expirationDateInput)) {
            event.preventDefault();
        }
    }
    onInputExipirationDate() {
        const newValue = this.expirationDateInput.value;
        this.state[this.expirationDate.name] = {
            error: credit_card_validation_1.CreditCardValidation.getExpiryDateMessage(newValue),
            isValid: credit_card_validation_1.CreditCardValidation.isValidExpiryDate(newValue),
            isFocused: true,
            value: newValue
        };
        this.notifyChangeState();
    }
    onkeydownExpirationDate(event) {
        credit_card_validation_1.CreditCardValidation.formatExpiry(event, this.expirationDateInput);
    }
    getNewToken() {
        return new Promise((resolve, reject) => {
            if (!this.state[this.cvv.name].isValid || !this.state[this.expirationDate.name].isValid) {
                return reject(mappers_1.mapTokenizerErrorResponse('lib', { message: error_types_contants_1.ErrorTypes.NEED_FILL_ALL_FIELDS }, 0));
            }
            Spreedly.recache();
            Spreedly.on('errors', (errors) => reject(mappers_1.mapTokenizerErrorResponse('provider', errors, 400)));
            Spreedly.on('recache', (token) => {
                const [month, year] = this.expirationDateInput.value.split(credit_card_constants_1.EXPIRATION_DATE_SEPARATOR);
                resolve({
                    fullDate: this.expirationDateInput.value,
                    month: Number(month.trim()),
                    year: Number(`${credit_card_constants_1.FIRST_TWO_DIGITS_OF_THE_CURRENT_CENTURY}${year.trim()}`),
                    token
                });
            });
        });
    }
    removeHandlers() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.removeHandlers();
            this.eventBus.removeEventListener();
        }
    }
    initState() {
        this.state = {
            [this.cvv.name]: this.getInitialState(),
            [this.expirationDate.name]: this.getInitialState()
        };
    }
    getInitialState(isValid = false, value = '') {
        return {
            error: error_types_contants_1.ErrorTypes.EMPTY,
            isFocused: false,
            isValid,
            value
        };
    }
}
exports.ReplaceCardManager = ReplaceCardManager;
